import { useMutation, useQueryClient } from '@tanstack/react-query';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';

import userSchema from '../../users.schema';
import useForm from '../../../../lib/hooks/useForm';
import { editUser, useGetPopulationSegments } from '../../data';

export default function useEditUserForm({ user }) {
  const queryClient = useQueryClient();
  const currentBoard = useSelector(state => state.currentBoard);
  const populationSegments = useGetPopulationSegments();
  const { mutate } = useMutation(editUser, {
    onSuccess: () => {
      queryClient.invalidateQueries(['getUsers']);
      Swal.close();
    },
  });

  const initialValues = {
    name: user.name,
    email: user.email,
    phoneNumber: user.phoneNumber,
    isAdmin: !!user.isAdmin,
    segments: user.populationSegments
      .filter(s => s.checked)
      .map(s => ({ value: s.id, label: s.name })),
    employeeId: user.employeeId || '',
  };

  const onSubmit = values => {
    mutate({ user: values, userId: user.uuid });
  };

  const validate = async values => {
    try {
      await userSchema.validate(values, {
        abortEarly: false,
        context: { useEmployeeId: currentBoard.useEmployeeId },
      });
      return {};
    } catch (e) {
      if (!e.inner) return {};
      return e.inner.reduce((acc, curr) => {
        if (curr.path && !acc[curr.path]) acc[curr.path] = curr.message;
        return acc;
      }, {});
    }
  };

  const form = useForm({
    initialValues,
    onSubmit,
    validate,
  });

  const handleSegmentChange = value => {
    form.setFieldValue('segments', value || []);
  };

  return { ...form, handleSegmentChange, populationSegments };
}
